// Sales AI Chat Constants

export const SALES_AI_ASSISTANT = {
  name: 'TagInn Assistant',
  initial: 'T',
  tagline: "Learn how TagInn can help your business",
};

export const SALES_TIME_GREETINGS: Record<string, string[]> = {
  morning: ['Good morning', 'Hello', 'Hi there'],
  afternoon: ['Good afternoon', 'Hello', 'Hi'],
  evening: ['Good evening', 'Hello', 'Hi there'],
  night: ['Hello', 'Hi there', 'Welcome'],
};

export const SALES_INVITATIONS = [
  "How can I help you learn about TagInn?",
  "What would you like to know about TagInn?",
  "I'm here to answer your questions.",
  "Ask me anything about our platform.",
];

export const SALES_QUICK_SUGGESTIONS = [
  { text: "What does TagInn do?" },
  { text: "Tell me about pricing plans" },
  { text: "How does employee scheduling work?" },
  { text: "I'd like to schedule a demo" },
];

// Sales AI endpoint
export const SALES_AI_ENDPOINT = import.meta.env.VITE_SALES_AI_ENDPOINT
  || (import.meta.env.DEV ? 'http://localhost:3001/api/sales-ai-chat' : 'https://pass.taginn.app/api/sales-ai-chat');
